var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketIconSolved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H31.9852C40.8218 0 47.9852 7.16344 47.9852 16V31.9852C47.9852 40.8218 40.8218 47.9852 31.9852 47.9852H16C7.16344 47.9852 0 40.8218 0 31.9852V16Z",
    fill: "#F0FDF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9873 20.9935C14.7827 20.9935 15.5455 21.3095 16.108 21.872C16.6704 22.4344 16.9864 23.1972 16.9864 23.9926C16.9864 24.788 16.6704 25.5509 16.108 26.1133C15.5455 26.6757 14.7827 26.9917 13.9873 26.9917V28.9911C13.9873 29.5214 14.198 30.0299 14.5729 30.4049C14.9479 30.7798 15.4564 30.9905 15.9867 30.9905H31.9818C32.512 30.9905 33.0206 30.7798 33.3955 30.4049C33.7705 30.0299 33.9811 29.5214 33.9811 28.9911V26.9917C33.1857 26.9917 32.4229 26.6757 31.8605 26.1133C31.298 25.5509 30.9821 24.788 30.9821 23.9926C30.9821 23.1972 31.298 22.4344 31.8605 21.872C32.4229 21.3095 33.1857 20.9935 33.9811 20.9935V18.9942C33.9811 18.4639 33.7705 17.9553 33.3955 17.5804C33.0206 17.2054 32.512 16.9948 31.9818 16.9948H15.9867C15.4564 16.9948 14.9479 17.2054 14.5729 17.5804C14.198 17.9553 13.9873 18.4639 13.9873 18.9942V20.9935Z",
    stroke: "#00A63E",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9839 16.9948V18.9948",
    stroke: "#00A63E",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9839 28.9911V30.9911",
    stroke: "#00A63E",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9839 22.9929V24.9929",
    stroke: "#00A63E",
    strokeWidth: 1.99938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIconSolved);
export default __webpack_public_path__ + "static/media/ticket_icon_solved.36360679d3fcd5a80426ac0bd8276899.svg";
export { ForwardRef as ReactComponent };